module.exports = __webpack_public_path__ + "resources/img/bg_cover_partner.f476090f183560149c790737a5791262.png";